import React from 'react'
import { useTranslation } from 'react-i18next'
import ShareOffer from 'src/common/components/ShareOffer/ShareOffer'
import { Offer } from 'src/common/types/models/Offer'
import Modal, { ModalProps } from 'src/common/ui-kit/Modal'
import { ZERO } from 'src/common/utils/big-utils'

interface ShareOfferModalProps extends ModalProps {
  offer: Offer | null
}

const ShareOfferModal: React.FC<ShareOfferModalProps> = ({
  onClose,
  offer,
  ...rest
}) => {
  const { t } = useTranslation('offersManagement', { keyPrefix: 'offerShare' })

  return (
    <Modal onClose={onClose} {...rest}>
      {offer && (
        <div>
          <h2 className='modal-title mb-4'>{t('title')}</h2>
          <ShareOffer
            tokenIn={offer.depositAsset}
            tokenOut={offer.withdrawalAsset}
            amountIn={offer.amountIn}
            amountOut={offer.amountOut || ZERO}
            offerId={offer.id}
            className='w-full'
          />
        </div>
      )}
    </Modal>
  )
}

export default ShareOfferModal
